import { useTranslate } from '@prenuvo/halo';

import { useStudyGuard } from '@/shared/guard';
import { transformSnakeCaseToPascalCase } from '@/shared/util';

export function PatientGender() {
  const { patient } = useStudyGuard();
  const translate = useTranslate();

  return (
    <span className="border-x-2 px-2 py-1" data-testid="patient-gender">
      {patient?.gender
        ? transformSnakeCaseToPascalCase(patient?.gender)
        : translate('FCT.REPORTING.HEADER.UNKNOWN.GENDER')}
    </span>
  );
}
